var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { clearCustomRequest, customRequestApis, } from "../../../store/customRequest/actions";
import { CATALOG_TYPE_PAYMENT_MODE } from "../constants/planCreation.constants";
import { useRequestState } from "./useRequestState";
var REQUEST_KEY = "getPlanCreationPaymentModes";
export var useGetPlanPaymentModes = function () {
    var dispatch = useDispatch();
    var _a = useRequestState(REQUEST_KEY), data = _a.data, loading = _a.loading, error = _a.error;
    var fetchPaymentModes = function (params) {
        dispatch(customRequestApis({
            requestKey: REQUEST_KEY,
            method: "GET",
            path: "/asg/Api/V1/Catalog",
            queryParams: __assign(__assign({}, params), { type: CATALOG_TYPE_PAYMENT_MODE }),
        }));
    };
    useEffect(function () {
        return function () {
            dispatch(clearCustomRequest(REQUEST_KEY));
        };
    }, []);
    return {
        fetchPaymentModes: fetchPaymentModes,
        paymentModes: data,
        loadingPaymentModes: loading,
        errorPaymentModes: error,
    };
};
